import { ThrivaApiRequestError } from './ThrivaApiRequestError';
export const THRIVA_API_SERVER_ERROR_NAME = 'ThrivaApiServerError';
export class ThrivaApiServerError extends ThrivaApiRequestError {
    constructor(message = 'SERVER_ERROR', url, options, code, response) {
        super(message, url, options, code, response);
        this.name = THRIVA_API_SERVER_ERROR_NAME;
        this.message = `${code}: ${message}`;
        this.apiErrorType = 'api_error';
        // restore prototype chain, see https://stackoverflow.com/questions/41102060/typescript-extending-error-class
        // Also see https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // and https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#custom_error_types
        const actualProto = new.target.prototype;
        Object.setPrototypeOf(this, actualProto);
    }
}
//# sourceMappingURL=ThrivaApiServerError.js.map